import type { ReactNode } from 'react';
import { styles } from '@/shared/app-stepper-form/styles';
import { StepRail } from '@/shared/app-stepper-form/parts/step-rail';
import { StepperHelpCard } from '@/shared/app-stepper-form/parts/stepper-help-card';
import type { StepState } from '@/shared/app-stepper-form/hooks/use-stepper';
import type { StepDefinition } from '@/shared/app-stepper-form/types';

/**
 * The left column of the shared card: the step rail and the help note.
 *
 * Split out of `AppStepperForm` so the composition stays inside the
 * function-length budget, and because the column is a unit — the rail and the
 * help card are laid out together, with the help card pushed to the foot by
 * `mt-auto`. Keeping them in one part means that relationship is stated once.
 *
 * The column is `hidden ... lg:flex`, so it does not exist below `lg`. The phone
 * gets the same information through `StepSheet` in the panel header instead.
 */
export function StepRailColumn({
  steps,
  states,
  activeIndex,
  furthestReached,
  onJump,
}: {
  steps: ReadonlyArray<StepDefinition>;
  states: ReadonlyArray<StepState>;
  activeIndex: number;
  furthestReached: number;
  onJump: (index: number) => void;
}): ReactNode {
  return (
    <div className={styles.rail}>
      <StepRail
        steps={steps}
        states={states}
        activeIndex={activeIndex}
        furthestReached={furthestReached}
        onJump={onJump}
      />
      <StepperHelpCard />
    </div>
  );
}
